<div class="d-flex justify-content-between align-items-end pb-3 px-3 autocomlete-header">
  <h1 mat-dialog-title class="text-black fw-medium p-0 mb-0">
    <span>{{ 'groupManagement.button.updateGroup' | translate }}</span>
  </h1>

  <button class="border-0 bg-transparent delete-btn" (click)="onClose()">
    <i class="das das-corss fs-12 close-btn"></i>
  </button>
</div>

<!-- Dialog Content -->
<mat-dialog-content class="dialog-content">
  <div class="px-3">
    <!-- Group Name Input -->
    <div class="field-wrapper full-width mb-3">
      <label for="groupNameInput" class="form-label fs-14 fw-medium">{{
        'groupManagement.labels.groupName' | translate
      }}</label>
      <mat-form-field appearance="outline" class="full-width">
        <input
          id="groupNameInput"
          matInput
          placeholder="{{ 'groupManagement.labels.enterGroupName' | translate }}"
          class="fs-14"
          [(ngModel)]="groupName"
          (keydown)="$event.stopPropagation()"
        />
      </mat-form-field>
    </div>

    <!-- Search Users -->
    <div class="field-wrapper full-width mb-3">
      <label for="searchUsersInput" class="form-label fs-14 fw-medium">{{
        'groupManagement.labels.searchUsers' | translate
      }}</label>
      <mat-form-field appearance="outline" class="full-width edu-search">
        <input
          id="searchUsersInput"
          matInput
          placeholder="{{ 'groupManagement.labels.searchByNameOrEmail' | translate }}"
          class="fs-14"
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange($event)"
          (keydown)="$event.stopPropagation()"
        />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>

    <!-- Users Selected Count -->
    <div class="users-selected pb-2">
      <span class="users-text fs-14 text-muted">{{ 'groupManagement.labels.usersSelected' | translate }}: </span>
      <span class="users-count fs-14 text-dark fw-medium">{{ selectedCount }}</span>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="loading-container d-flex justify-content-center align-items-center py-5">
      <mat-spinner diameter="40"></mat-spinner>
      <span class="ms-3">{{ 'common.loading' | translate }}</span>
    </div>

    <!-- Background Loading Indicator -->
    <div *ngIf="!loading && loadingMore" class="loading-more-indicator text-center py-2">
      <mat-spinner diameter="20" class="d-inline-block me-2"></mat-spinner>
      <span class="fs-12 text-muted"> Loading more users... ({{ loadedUsersCount }} / {{ totalUsersCount }}) </span>
    </div>

    <!-- Users List -->
    <div *ngIf="!loading" class="users-list-container">
      <div class="users-list">
        <div
          *ngFor="let user of filteredUsers"
          class="user-item d-flex align-items-center justify-content-between p-2 mb-2"
          [class.selected]="user.isSelected"
        >
          <div class="user-info d-flex align-items-center flex-grow-1">
            <mat-checkbox
              [checked]="user.isSelected"
              (change)="onUserSelectionChange(user, $event.checked)"
              class="me-3"
            ></mat-checkbox>
            <div class="user-details">
              <div class="user-name fs-14 fw-medium">{{ getUserFullName(user) }}</div>
              <div class="user-email fs-12 text-muted">{{ user.email }}</div>
              <div *ngIf="user.entity_name" class="user-entity fs-12 text-muted">
                <i class="das das-building me-1"></i>{{ user.entity_name }}
              </div>
            </div>
          </div>
          <div *ngIf="user.isOriginalMember" class="badge bg-primary fs-12">
            {{ 'groupManagement.labels.currentMember' | translate }}
          </div>
        </div>

        <!-- No Results -->
        <div *ngIf="filteredUsers.length === 0" class="no-results text-center py-4">
          <i class="das das-search fs-1 text-muted"></i>
          <p class="text-muted fs-14 mt-2">{{ 'common.noResultsFound' | translate }}</p>
        </div>
      </div>
    </div>

    <hr class="my-3" />

    <!-- Info Message -->
    <span class="d-flex align-items-start gap-2 ext-info">
      <i class="das das-info-icon text-dark fs-5 m-0 p-0 mt-1"></i>
      <p class="text-muted fs-14 mb-0 lh-sm">
        {{ 'groupManagement.updateGroupInformation' | translate }}
      </p>
    </span>
  </div>
</mat-dialog-content>

<!-- Dialog Actions -->
<mat-dialog-actions class="px-3 pt-3 pb-3 d-flex gap-3" align="end">
  <button
    class="btn rounded-1 fs-14 btn-primary px-5 fw-bold white-space-nowrap"
    (click)="onSubmit()"
    [disabled]="!isUpdateEnabled || isSubmitting"
  >
    <span *ngIf="!isSubmitting">{{ 'groupManagement.button.update' | translate }}</span>
    <span *ngIf="isSubmitting">
      <mat-spinner diameter="20" class="d-inline-block me-2"></mat-spinner>
      {{ 'common.updating' | translate }}
    </span>
  </button>
  <button class="btn btn-outline-primary fw-bold px-5 fs-14 rounded-1" (click)="onCancel()">
    {{ 'actions.cancel' | translate }}
  </button>
</mat-dialog-actions>
